import { z } from 'zod/v4';

import { UNDEFINED_ENUM } from '../../../models/undefined-enum';
import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const tollRoadTypeOptions = [
  UNDEFINED_ENUM,
  'AlwaysAvoid',
  'AvoidIfPossible',
  'Use',
] as const;

export const tollRoadTypeSchema = createEnumSchemaPreprocessor(
  z.enum(tollRoadTypeOptions),
  tollRoadTypeOptions
);

export type TollRoadType = z.infer<typeof tollRoadTypeSchema>;
